// src/components/GalleryImage.jsx

// Image cliquable simple (ouvre la lightbox). Pas de protection technique :
// une fois affichée en grand au clic, un clic droit désactivé ne sert à
// rien. La mention de droits se fait par le texte, pas par la friction.
export default function GalleryImage({ src, alt, className, onClick }) {
    return (
        <button type="button" className={`gallery-image ${className ?? ''}`} onClick={onClick}>
            <img src={src} alt={alt} loading="lazy" />
        </button>
    );
}
